export const THEME_COOKIE = "be-theme";
export const THEME_STORAGE_KEY = "be-theme";

export type ThemePreference = "light" | "dark" | "system";
export type ResolvedTheme = "light" | "dark";

export function isThemePreference(value: unknown): value is ThemePreference {
  return value === "light" || value === "dark" || value === "system";
}

export function resolveTheme(
  preference: ThemePreference,
  systemDark: boolean,
): ResolvedTheme {
  if (preference === "system") {
    return systemDark ? "dark" : "light";
  }
  return preference;
}

/** Inline script — apply theme before paint to avoid flash. */
export const themeInitScript = `(function(){try{var k=${JSON.stringify(THEME_STORAGE_KEY)};var c=document.cookie.match(/(?:^|; )${THEME_COOKIE}=([^;]*)/);var p=localStorage.getItem(k)||(c&&decodeURIComponent(c[1]))||"system";if(p!=="light"&&p!=="dark"&&p!=="system")p="system";var d=window.matchMedia("(prefers-color-scheme: dark)").matches;var r=p==="system"?(d?"dark":"light"):p;var e=document.documentElement;e.classList.toggle("dark",r==="dark");e.style.colorScheme=r;e.dataset.theme=r;}catch(e){}})();`;
